import AuroraBackground from "@/components/AuroraBackground";
import Reveal from "@/components/Reveal";

// Shared hero header for interior pages (support, legal, contact).
export const PageHeader = ({ eyebrow, title, subtitle, updated }) => (
  <section className="relative overflow-hidden pt-32 pb-14 sm:pt-40 sm:pb-16">
    <AuroraBackground variant="soft" />
    <div className="container-nova relative">
      <Reveal>
        {eyebrow && <p className="label-eyebrow mb-4">{eyebrow}</p>}
        <h1 className="max-w-3xl font-heading text-4xl font-800 leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" style={{ fontWeight: 800 }}>
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg">{subtitle}</p>}
        {updated && <p className="mt-4 text-xs uppercase tracking-[0.2em] text-white/40">Last updated {updated}</p>}
      </Reveal>
    </div>
  </section>
);

// Readable legal/prose container.
export const Prose = ({ children }) => (
  <div className="prose-nova max-w-3xl space-y-6 text-[15px] leading-relaxed text-white/70">
    {children}
  </div>
);

export const LegalSection = ({ id, heading, children }) => (
  <section id={id} className="scroll-mt-28">
    <h2 className="font-heading text-xl font-bold text-white sm:text-2xl">{heading}</h2>
    <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-white/65">{children}</div>
  </section>
);

export default PageHeader;
